/**
 * Sanitizes a string to allow only numeric characters.
 * @param value The string to sanitize.
 * @param allowDecimal Whether to allow a single decimal point.
 * @returns The sanitized string.
 */
export const sanitizeNumeric = (value: string, allowDecimal = false): string => {
  if (allowDecimal) {
    // Allow only digits and a single decimal point
    const sanitized = value.replace(/[^0-9.]/g, '');
    const parts = sanitized.split('.');
    if (parts.length > 2) {
      return parts[0] + '.' + parts.slice(1).join('');
    }
    return sanitized;
  }
  // Allow only digits
  return value.replace(/\D/g, '');
};
